import { render, staticRenderFns } from "./DetailUserInfo.vue?vue&type=template&id=d3939626"
import script from "./DetailUserInfo.vue?vue&type=script&lang=js"
export * from "./DetailUserInfo.vue?vue&type=script&lang=js"
import style0 from "./DetailUserInfo.vue?vue&type=style&index=0&id=d3939626&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports